import type {Reducer} from '@/redux/types';
import type {V1OffersState} from '@/redux/typesNew';

import {combineReducers} from 'redux';

import {inventoryReducer} from '@/redux/v1/offers/inventory/reducer';
import {listReducer} from '@/redux/v1/offers/list/reducer';

export const offersReducer: Reducer<V1OffersState> = combineReducers({
  list: listReducer,
  inventory: inventoryReducer,
});
